module.exports = __webpack_public_path__ + "img/447.15ba30d2.jpg";